const SelectedMealReducer = (state = { SelectedMeals: [] }, action) => {
  switch (action.type) {
    case "SelectedMeal":
      return { ...state, SelectedMeals: action.payload };
    default:
      return state;
  }
};
export default SelectedMealReducer;
